import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const box = geo.createNode('box');

	// add a subdivide node
	const subdivide = geo.createNode('subdivide');
	subdivide.setInput(0, box);
	subdivide.flags.display.set(true);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [subdivide],
		autoLayout: true,
	};
}
// export const sopSubdivide = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/subdivide`,
// 		createData,
// 		relatedNodes: [SubdivideSopNode],
// 	}),
// ];
